export default (percentage: string) => {
  // BSL does not always provide a %
  const per = percentage || '';
  return per && !per.endsWith('%') ? `${per}%` : per;
};
